import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { sentinelModule } from "../modules/sentinelModule";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { accountSettings_template } from "../components/templates/accountSettings_template";
import { vnApp_sentinelbi } from "../components/vnApp_sentinelbi";

declare var ko: any;
declare var page: any;

export class accountSettings extends sentinelModule {

    protected XHRHdl: XMLHttpRequestHandler;
    protected accountSettings_template: accountSettings_template;
    protected validationsList: validationsList_template;

    protected getModuleName(){

        return "accountSettings";
    }

    buildContent() : Array<Element>{

        const parentContent = super.buildContent();

        // create the accountSettings list
        this.accountSettings_template = new accountSettings_template("accountSettings_template", this.viewModel, this);

        // create validation errors list template
        this.validationsList = new validationsList_template("validationList", this.viewModel, this);

        return [...parentContent, this.validationsList.build(), this.accountSettings_template.build()];
    }

    fillPage() : void{
    
        this.getFormData();
        this.getPermissions();
    }

    protected filterSingleGroupSelectorOnChange(){

        this.loadingIn(this.accountSettings_template.builtTemplate);

        let usrReq_url: string = '/api/settings/account_details/pixel/get';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.accountSettings_template.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetPixelReturn;
        this.XHRHdl.execute();
    }

    protected onGetPixelReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                obj.loadingOut(obj.accountSettings_template.builtTemplate);
                obj.accountSettings_template.getTemplateViewModel().pixelCode(responseParsed);
            });
        }
    }

    protected getPermissions(){

        this.loadingIn(this.accountSettings_template.builtTemplate);

        let accPermissions_url: string = '/api/settings/menuData';
        let accPermissions_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(accPermissions_url, accPermissions_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetPermissionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetPermissionsReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                obj.loadingOut(obj.accountSettings_template.builtTemplate);
                obj.accountSettings_template.setSideMenuPermissionsData(responseParsed);
            })
        }
    }

    //
    // obtain the dynamic data required to fill the formulary
    protected getFormData(){

        this.loadingIn(this.accountSettings_template.builtTemplate);

        let usrReq_url: string = '/api/settings/account_details/get';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.accountSettings_template.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
        this.XHRHdl.execute();
    }
    //
    // use the form data to fill the form
    protected onGetFormDataReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                obj.setFormData(responseParsed);

                obj.loadingOut(obj.accountSettings_template.builtTemplate);
                obj.validationsList.clearMessages();

            });
        }
    }

    protected setFormData(data){

        this.accountSettings_template.setFormData(data);
    }

    public copyToClipboardNotification(){

        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Copied to clipboard");
        this.getVnAppZone().showNotificationToModule();
    }
}



// WEBPACK FOOTER //
// ./js/modules/accountSettings.ts